module.exports = __webpack_public_path__ + "img/ide-math.ddb31c9e.svg";